import apiService from './apiService';

interface Plant {
  plant_id: number;
  plant_name: string;
  [key: string]: any;
}

interface Line {
  line_id: number;
  line_code: string;
  line_name: string;
  [key: string]: any;
}

interface ApiResponse<T> {
  success: boolean;
  data: T;
  message?: string;
}

/**
 * Metadata API service
 * Handles API calls for plant and line metadata
 */

/**
 * Get all plants
 * @returns {Promise<Object>} Plants data
 */
export const getPlants = async (): Promise<ApiResponse<Plant[]>> => {
  try {
    const response = await apiService.get('/metadata/plants');
    return response;
  } catch (error) {
    console.error('Error fetching plants data:', error);
    throw error;
  }
};

/**
 * Get lines for a specific plant
 * @param {number} plantId - The plant ID
 * @returns {Promise<Object>} Lines data for the plant
 */
export const getLinesByPlant = async (plantId: number): Promise<ApiResponse<Line[]>> => {
  try {
    const response = await apiService.get(`/metadata/plants/${plantId}/lines`);
    return response;
  } catch (error) {
    console.error(`Error fetching lines for plant ${plantId}:`, error);
    throw error;
  }
};

export default {
  getPlants,
  getLinesByPlant,
};
